<template>
    <div>
        <v-row
            v-if="loading"
            class="fill-height mt-3"
            align="center"
            justify="center"
        >
            <v-progress-circular
                indeterminate
                color="primary"
            ></v-progress-circular>
        </v-row>
        <v-row v-if="!loading" class="align-center font-weight-bold mt-4">
            <v-col>
                <span>Sales Rep Information</span>
            </v-col>
        </v-row>
        <template v-if="!loading && leadSalesReps">
            <template v-for="block in repBlocks">
                <v-row
                    :key="'rep-company-' + block.id"
                    class="align-center mt-3 mb-4"
                    no-gutters
                >
                    <v-col
                        cols="4"
                        xl="2"
                        lg="2"
                        md="2"
                        sm="2"
                        class="d-flex align-center"
                    >
                        <span>Company</span>
                    </v-col>
                    <v-col>
                        <template v-if="canChangeCompany && !historyQuote">
                            <v-btn
                                v-if="editingRepId !== block.id"
                                text
                                class="grey--text text--darken-1 text-body-2 text-capitalize"
                                @click="editingRepId = block.id"
                            >
                                {{ block.name }}
                                <v-icon>mdi-menu-down</v-icon>
                            </v-btn>
                            <v-autocomplete
                                v-else
                                flat
                                solo
                                hide-details
                                :value="block.id"
                                :items="salesReps"
                                item-text="name"
                                item-value="id"
                                @change="id => replaceSalesRep(block.id, id)"
                            />
                        </template>
                        <span v-else>{{ block.name }}</span>
                    </v-col>
                </v-row>
                <v-row
                    :key="'rep-contacts-' + block.id"
                    class="my-2"
                    no-gutters
                >
                    <v-col
                        cols="3"
                        xl="2"
                        lg="2"
                        md="2"
                        sm="2"
                        class="d-flex align-top"
                    >
                        <span>Contacts</span>
                    </v-col>
                    <v-col
                        cols="9"
                        xl="10"
                        lg="10"
                        md="10"
                        sm="10"
                        class="d-flex align-center flex-wrap"
                        :style="{ 'row-gap': '20px' }"
                    >
                        <v-card
                            v-for="contact in block.contacts"
                            :key="contact.id"
                            flat
                            class="mr-1"
                            :style="{ width: '100%' }"
                        >
                            <div v-if="contact && contact.name" class="d-flex">
                                <v-avatar
                                    color="grey lighten-4"
                                    size="34"
                                    class="mr-1"
                                >
                                    <v-img
                                        v-if="contact.profilePicURL"
                                        :src="contact.profilePicURL"
                                        :alt="contact.name"
                                    />
                                    <span v-else class="text-h6">
                                        {{ initials(contact.name) }}
                                    </span>
                                </v-avatar>
                                <div
                                    class="d-flex flex-column justify-space-around me-4"
                                >
                                    <span
                                        class="font-weight-bold text-singleline"
                                    >
                                        {{ contact.name }}
                                        {{
                                            contact.role
                                                ? `(${contact.role})`
                                                : ''
                                        }}
                                    </span>
                                    <span class="text-caption text-singleline">
                                        {{ contact.phone }}
                                        {{
                                            contact.phone2
                                                ? `- ${contact.phone2}`
                                                : ''
                                        }}
                                    </span>
                                    <span class="text-caption text-singleline">
                                        {{ contact.email }}
                                    </span>
                                </div>
                            </div>
                        </v-card>
                    </v-col>
                </v-row>
            </template>
        </template>
        <v-row
            v-if="!loading && !leadSalesReps"
            class="align-center mt-3 mb-4"
            no-gutters
        >
            <v-col
                cols="4"
                xl="2"
                lg="2"
                md="2"
                sm="2"
                class="d-flex align-center"
            >
                <span>Company</span>
            </v-col>
            <v-col
                v-if="!historyQuote && quote"
                cols="8"
                class="d-flex align-center"
            >
                <div v-if="textRep && salesRep">
                    <v-btn
                        :disabled="!canChangeCompany"
                        @click="dialogRep = true"
                        class="grey--text text--darken-1 text-body-2 text-capitalize"
                        text
                    >
                        {{ salesRep.name }}
                        <v-icon>mdi-menu-down</v-icon>
                    </v-btn>
                </div>
                <v-autocomplete
                    v-if="changeRep || !salesRep"
                    :disabled="!canChangeCompany"
                    flat
                    solo
                    hide-details
                    v-model="selectedRepId"
                    :items="salesReps"
                    item-text="name"
                    item-value="id"
                    @change="selectRep"
                ></v-autocomplete>
            </v-col>
            <v-col v-if="historyQuote">
                <span>{{ salesRep ? salesRep.name : '' }}</span>
            </v-col>
        </v-row>
        <v-row v-if="!loading && !leadSalesReps" class="my-2" no-gutters>
            <v-col
                cols="3"
                xl="2"
                lg="2"
                md="2"
                sm="2"
                class="d-flex align-top"
            >
                <span>Contacts</span>
            </v-col>
            <v-col
                v-if="quote"
                cols="9"
                xl="10"
                lg="10"
                md="10"
                sm="10"
                class="d-flex align-center flex-wrap"
                :style="{ 'row-gap': '20px' }"
            >
                <v-combobox
                    v-model="dataContacts"
                    :disabled="quote.archive == true || historyQuote"
                    :items="contacts"
                    flat
                    hide-details
                    item-text="name"
                    class="ml-2"
                    label="Search contact"
                    multiple
                    @change="saveContacts"
                ></v-combobox>
            </v-col>
        </v-row>
        <v-row v-if="!leadSalesReps">
            <v-spacer />
            <v-col
                v-if="quote"
                cols="9"
                xl="10"
                lg="10"
                md="10"
                sm="10"
                class="d-flex align-center flex-wrap"
                :style="{
                    'row-gap': '20px',
                    'max-height': '500px',
                    'overflow-y': 'auto',
                }"
            >
                <v-card
                    v-for="contact in dataContacts"
                    :key="contact.id"
                    flat
                    class="mr-1"
                    :style="{ width: '100%' }"
                >
                    <div v-if="contact && contact.name" class="d-flex">
                        <v-avatar color="grey lighten-4" size="34" class="mr-1">
                            <v-img
                                v-if="contact.profilePicURL"
                                :src="contact.profilePicURL"
                                :alt="contact.name"
                            />
                            <span v-else class="text-h6">
                                {{ initials(contact.name) }}
                            </span>
                        </v-avatar>
                        <div
                            class="d-flex flex-column justify-space-around me-4"
                        >
                            <span class="font-weight-bold text-singleline">
                                {{ contact.name }}
                                {{ contact.role ? `(${contact.role})` : '' }}
                            </span>
                            <span class="text-caption text-singleline">
                                {{ contact.phone }}
                                {{
                                    contact.phone2 ? `- ${contact.phone2}` : ''
                                }}
                            </span>
                            <span class="text-caption text-singleline">
                                {{ contact.email }}
                            </span>
                        </div>
                    </div>
                </v-card>
            </v-col>
        </v-row>
        <v-dialog v-model="dialogRep" persistent max-width="400px">
            <v-card>
                <v-card-title class="text-h5">Change Sales Rep</v-card-title>
                <v-card-text>
                    Are you sure you want to change the sales rep?
                </v-card-text>
                <v-card-actions>
                    <v-btn text color="secondary" @click="dialogRep = false">
                        Close
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn text color="error" @click="allowChange">
                        Change
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import { mapMutations } from 'vuex'
import API from '@/services/api'
import {
    marginsForCommissions,
    mergeSalesRepCommissions,
    quoteSalesRepIds,
    salesRepCommissionShare,
    salesRepCommissionsManual,
    salesRepPercentKey,
    commissionBaseUsd,
} from '@/utils/salesRepQuoteCommissions.js'
import { storage } from '@/services/firebase'

export default {
    name: 'SalesRepInformationQuote',
    props: {
        quote: Object,
        historyQuote: Boolean,
        quoteStatus: String,
        settings: Array,
    },
    data() {
        return {
            loading: false,
            textRep: true,
            changeRep: false,
            dialogRep: false,
            salesReps: [],
            salesRep: null,
            selectedRepId: null,
            contacts: [],
            dataContacts: [],
            hydrating: false,
            editingRepId: null,
            companyId: JSON.parse(localStorage.getItem('company')),
            folderClientsPictures: 'clients_pictures',
        }
    },
    computed: {
        canChangeCompany() {
            return (
                this.quoteStatus === 'OPEN' || this.quoteStatus === 'APPROVAL'
            )
        },
        leadSalesReps() {
            return (this.quote?.salesRepIds || []).length > 0
        },
        repBlocks() {
            const ids = this.quote?.salesRepIds || []
            const selected = new Set(
                (
                    this.quote?.salesRepContactIds ||
                    this.quote?.clientCollaborators ||
                    []
                ).map(id => String(id))
            )
            return ids.map(id => ({
                id,
                name:
                    (this.salesReps.find(rep => rep.id === id) || {}).name ||
                    id,
                contacts: this.contacts.filter(
                    contact =>
                        contact.salesRepId === id &&
                        selected.has(String(contact.id))
                ),
            }))
        },
    },
    watch: {
        'quote.id': function() {
            this.load()
        },
    },
    methods: {
        ...mapMutations(['setErrorItems']),
        initials(name) {
            return name
                .split(' ')
                .map((n, i, a) => (i === 0 || i + 1 === a.length ? n[0] : null))
                .join('')
                .toUpperCase()
        },
        allowChange() {
            this.changeRep = true
            this.textRep = false
            this.dialogRep = false
            this.selectedRepId = this.salesRep ? this.salesRep.id : null
        },
        async saveQuote(fields) {
            await API.updateQuote(this.quote.id, fields)
        },
        async replaceSalesRep(oldId, newId) {
            this.editingRepId = null
            if (!newId || String(newId) === String(oldId)) return
            const ids = [...(this.quote.salesRepIds || [])]
            if (ids.some(id => String(id) === String(newId))) return
            const index = ids.findIndex(id => String(id) === String(oldId))
            if (index < 0) return
            ids[index] = newId
            this.$set(this.quote, 'salesRepIds', ids)
            try {
                await this.saveQuote({ salesRepIds: ids })
                await this.recalculateSalesRepCommissions()
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            }
        },
        async recalculateSalesRepCommissions() {
            try {
                const ids = quoteSalesRepIds(this.quote)
                const reps = ids
                    .map(id =>
                        this.salesReps.find(
                            rep => String(rep.id) === String(id)
                        )
                    )
                    .filter(Boolean)
                if (!ids.length || reps.length !== ids.length) return
                const all = (await API.getCosts(this.quote.id)) || []
                const costs = all.filter(cost => cost.type !== 'alternate')
                const alternatives = all.filter(
                    cost => cost.type === 'alternate'
                )
                const hadManual = salesRepCommissionsManual(
                    this.quote.commissions
                )
                const base = commissionBaseUsd(costs, this.quote, this.settings)
                const lines = salesRepCommissionShare(reps, base)
                const next = mergeSalesRepCommissions(
                    this.quote.commissions,
                    lines
                )
                const same =
                    salesRepPercentKey(this.quote.commissions) ===
                    salesRepPercentKey(next)
                if (same && !hadManual) return
                if (!costs.length || !Number(this.quote.exchange)) {
                    this.$set(this.quote, 'commissions', next)
                    await this.saveQuote({ commissions: next })
                    return
                }
                const recalculatedCosts = marginsForCommissions(
                    costs,
                    next,
                    this.quote.exchange
                )
                const recalculatedAlternatives = marginsForCommissions(
                    alternatives,
                    next,
                    this.quote.exchange
                )
                const totalCosts = recalculatedCosts.reduce(
                    (sum, cost) => sum + (Number(cost.salePrice2) || 0),
                    0
                )
                const { quote } = await API.updateCommissions(this.quote.id, {
                    commissions: next,
                    costs: recalculatedCosts,
                    alternatives: recalculatedAlternatives,
                    totalCosts,
                })
                this.$set(this.quote, 'commissions', quote.commissions)
                this.$set(this.quote, 'totalCosts', quote.totalCosts)
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            }
        },
        async selectRep(id) {
            try {
                this.loading = true
                const rep = this.salesReps.find(item => item.id === id)
                if (!rep) return
                this.salesRep = rep
                this.selectedRepId = id
                this.$set(this.quote, 'salesRepIds', [id])
                this.$set(this.quote, 'clientCollaborators', [])
                this.dataContacts = []
                await this.saveQuote({
                    salesRepIds: [id],
                    clientCollaborators: [],
                })
                await this.loadContacts()
                await this.recalculateSalesRepCommissions()
                this.textRep = true
                this.changeRep = false
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loading = false
            }
        },
        async saveContacts() {
            if (this.hydrating) return
            try {
                const picked = (this.dataContacts || []).filter(
                    contact => contact && contact.id
                )
                this.dataContacts = picked
                const ids = picked.map(contact => contact.id)
                this.$set(this.quote, 'clientCollaborators', ids)
                await this.saveQuote({
                    clientCollaborators: ids,
                })
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            }
        },
        async attachPictures(contacts) {
            for (const contact of contacts) {
                if (!contact.picture) continue
                const path = `${this.companyId}/${this.folderClientsPictures}`
                const profilePicRef = storage()
                    .ref(path)
                    .child(contact.picture)
                await profilePicRef
                    .getDownloadURL()
                    .then(url => {
                        contact.profilePicURL = url
                    })
                    .catch(() => {
                        contact.profilePicURL = ''
                    })
            }
        },
        async loadContacts() {
            const repIds = this.quote.salesRepIds || []
            if (!repIds.length) {
                this.contacts = []
                this.dataContacts = []
                return
            }
            const results = await Promise.all(
                repIds.map(id => API.getContactsByClient({ clientId: id }))
            )
            console.log(results)
            const contacts = []
            results.forEach((res, index) => {
                ;(res?.data?.contacts || []).forEach(contact => {
                    if (!contacts.some(row => row.id === contact.id)) {
                        contacts.push({
                            ...contact,
                            salesRepId: repIds[index],
                        })
                    }
                })
            })
            await this.attachPictures(contacts)
            this.contacts = contacts
            const ids = new Set(
                (
                    this.quote.salesRepContactIds ||
                    this.quote.clientCollaborators ||
                    []
                ).map(id => String(id))
            )
            this.hydrating = true
            this.dataContacts = this.contacts.filter(contact =>
                ids.has(String(contact.id))
            )
            this.$nextTick(() => {
                this.hydrating = false
            })
        },
        async load() {
            const repIds = this.quote?.salesRepIds || []
            if (!this.quote || !repIds.length) {
                return
            }
            try {
                this.loading = true
                this.textRep = true
                this.changeRep = false
                const {
                    data: { clients },
                } = await API.getClients()
                this.salesReps = (clients || []).filter(
                    client => client.clientType === 'salesRep'
                )
                const repId = repIds[0]
                this.salesRep =
                    this.salesReps.find(client => client.id === repId) || null
                this.selectedRepId = this.salesRep ? this.salesRep.id : null
                await this.loadContacts()
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loading = false
            }
        },
    },
    mounted() {
        this.load()
    },
}
</script>
